import {autoserialize} from 'cerialize';
import File from "./File";

export default class Folder {
    @autoserialize public name: string;
    @autoserialize public order_index: number;
    @autoserialize public parent_folder_id: number;
    @autoserialize public folder_type: string;
    @autoserialize public id: number;
    @autoserialize public folders: Folder[];
    @autoserialize public files: File[];
    @autoserialize public demo_pdf_file: string;
    @autoserialize public demo_pdf_url: string;
    @autoserialize public demo_video_url: string;

    constructor(
        name: string,
        order_index: number,
        parent_folder_id: number,
        folder_type: string,
        id: number,
        folders: Folder[],
        files: File[],
        demo_pdf_file: string,
        demo_pdf_url: string,
        demo_video_url: string
    ) {

        this.name = name;
        this.order_index = order_index;
        this.parent_folder_id = parent_folder_id;
        this.folder_type = folder_type;
        this.id = id;
        this.folders = folders;
        this.files = files;
        this.demo_pdf_file = demo_pdf_file;
        this.demo_pdf_url = demo_pdf_url;
        this.demo_video_url = demo_video_url;
    }
}
